// extracted by mini-css-extract-plugin
export default {"pageContainer":"BackgroundLights_pageContainer__yaQlN","ball1":"BackgroundLights_ball1__8b2cx","ball2":"BackgroundLights_ball2__XMsUT","ball3":"BackgroundLights_ball3__-Ypii"};